import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams, HttpErrorResponse } from "@angular/common/http";
import { Country } from "mapfre-auditlib";
import { Observable, throwError } from "rxjs";
import * as _ from 'lodash';
import { catchError, map } from "rxjs/operators";
import { Region } from 'mapfre-auditlib';
import { AuthService, CacheService } from 'mapfre-auditlib';
import { Router } from '@angular/router';

@Injectable({
   providedIn: "root"
})
export class CountryService {

   className = 'CountryService'

   sections = [
      'administration',
      'works/dashboard',
      'recommendations/dashboard',
      'following'
   ]

   constructor(private http: HttpClient, private authService: AuthService, private router: Router, private cacheService: CacheService) { }

   getAllCountries(cache = true): Observable<Country[]> | any {
      const isAdminSection = _.some(this.sections, section => _.includes(this.router.url, section));
      let cacheKey = "allCountries"+"_"+isAdminSection.toString()
      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey);
       } else {
         let observable = this.http.get<Country[]>(environment.base_URL + "/countries").pipe(map((res) => {
            if(isAdminSection){
               this.cacheService.updateCacheData(res, cacheKey)
               return res;
            }else{
               let filtrado =  _.filter(res, it => it.mrkActive);
               this.cacheService.updateCacheData(filtrado, cacheKey)
               return filtrado;
            }
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
      }
   }

   //!NO se usa
   getAllRegions(): Observable<Country[]> {
      return this.getAllCountries().pipe(map((d: any) => {
         return _.uniqBy(_.map(d, (item: any) => item.region), 'txtRegion');
      }));
   }

   newCountry(country) {
      return this.http.post(environment.base_URL + "/countries", country)
   }

   updateCountry(country, id) {
      return this.http.put(environment.base_URL + `/countries/${id}`, country)
   }

   //!NO se usa
   getCountryByUser() {
      return this.authService.getUserAllSO().pipe(map((res: any) => {
         let countriesMap = _.map(res, (item: any) => {
            item.country.idOrganizationalStructurePk = [item.idOrganizationalStructurePk];
            return item.country;
         });

         const group = _.chain(countriesMap)
            .groupBy(x => x.idOrganizationalStructurePk)
            .map((value, key) => value)
            .value();

         let countries = _.map(group, country =>
            _.reduce(country, (item: any, next: any) => { item.idOrganizationalStructurePk = _.concat(item.idOrganizationalStructurePk, next.idOrganizationalStructurePk); return item; })
         );

         return _.uniqBy(countries, 'idCountryPk');
      }));
   }
}
